import fetch from "./fetch";
const HEALTHAPI = process.env.VUE_APP_HEALTH_API;

// 获取某一类型的代办任务提醒
export function getInterviewTaskInfo(params) {
	return fetch({
		baseUrl: HEALTHAPI,
		contentType: "application/json",
		url: "/task/getInterviewTaskInfo",
		method: "POST",
		params,
	});
}
//完成代办任务接口
export function completeTask(params) {
	return fetch({
		baseUrl: HEALTHAPI,
		contentType: "application/json",
		url: "/task/complete",
		method: "POST",
		params,
	});
}

// 轮询状态
export function getDemoStatus(params) {
	return fetch({
		baseUrl: HEALTHAPI,
		contentType: "application/json",
		url: "/event/passive/click",
		method: "POST",
		params,
	});
}

// 更改轮询状态
export function setDemoStatus(params) {
	return fetch({
		baseUrl: HEALTHAPI,
		contentType: "application/json",
		url: "/event/update/click/status",
		method: "POST",
		params,
	});
}

// 更新推送状态为已读(未读的消息将在用户下次登陆时重新推送.)
export function readPushNotify(params) {
	return fetch({
		baseUrl: HEALTHAPI,
		contentType: "application/json",
		url: "/event/readPushNotify",
		method: "POST",
		params,
	});
}
